import React from "react";

const UTCDateTime = ({ date, showDate = false }) => {
  if (!date) return <span>--</span>;

  const options = showDate
    ? {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }
    : {
        timeZone: "Asia/Kolkata",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      };

  let formatted = new Date(date).toLocaleString("en-GB", options);

  // ✅ Force AM / PM uppercase
  formatted = formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());

  return <span>{formatted}</span>;
};

export default UTCDateTime;
